import { useEffect, useRef } from 'react';

const IdleTimer = ({ onIdle }) => {
  const idleTimeoutRef = useRef(null);
  const idleTime = 8 * 60 * 60 * 1000; // 8 hours

  const resetIdleTimer = () => {
    if (idleTimeoutRef.current) {
      clearTimeout(idleTimeoutRef.current);
    }
    idleTimeoutRef.current = setTimeout(onIdle, idleTime);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
    const resetTimer = () => {
      resetIdleTimer();
    };

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetIdleTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (idleTimeoutRef.current) {
        clearTimeout(idleTimeoutRef.current);
      }
    };
  }, []);

  return null;
};

export default IdleTimer;
